import styled from 'styled-components';


export const PopupContainer = styled.div`
  position: relative;
  bottom: 8.8rem;
  right: 6px;
  background: #fff;
  color: #000;
  padding: 8px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 220px;

  .toll-plaza-info-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 8px;
    width: 100%;
  }

  .toll-plaza-info-close {
    flex: 0 0 auto;
    border: 0;
    background: transparent;
    color: #555;
    cursor: pointer;
    font-size: 12px;
    font-weight: 700;
    line-height: 1;
    padding: 2px;
  }

  &::after {
    content: "";
    position: absolute;
    bottom: -20px;
    left: 50%;
    transform: translateX(-50%);
    border-width: 10px;
    border-style: solid;
    border-color: #fff transparent transparent transparent;
  }
`;
